import Vue from "vue";
import { Pie } from 'vue-chartjs/legacy'
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    CategoryScale
} from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

Vue.component("pie-chart", {	
    props: ["id","width","height","dataKey","labels","data"],
    data() {
        return {
            cssClasses: '',
            styles: null,
            plugins: [], 
            chartData: this.data,
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                onClick: this.select
            }
        }
    },            	
    methods: {
        select(point, event) {
            console.log(point, event);
        }
    },
	template: `
		<pie
            :chart-options="chartOptions"
            :chart-data.sync="chartData"
            :chart-id="id"
            :dataset-id-key="dataKey"
            :plugins="plugins"
            :css-classes="cssClasses"
            :styles="styles"
            :width="width"
            :height="height"
          />
	`
});